import { useEffect } from "react";
import { createPortal } from "react-dom";
import { allCommonImages } from "../Assets/Images/images";
import { FaceDetection } from "../plugins/faceDetection";

let logo = allCommonImages.LogoWhite;

type FullScreenProgressProps = {
  progress: number;
  title?: string;
  message?: string;
  downloadedMb?: number;
  totalMb?: number;
};

const FullScreenProgress = ({
  progress,
  title = "App Update in Progress",
  message = "Downloading and applying the latest app update. Please keep the app open; the app will restart automatically once complete.",
  downloadedMb,
  totalMb,
}: FullScreenProgressProps) => {
  useEffect(() => {
    if (progress > 0) {
      FaceDetection.stopScan().catch(() => {});
    }
  }, [progress]);

  if (progress <= 0) return null;

  const content = (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 200000,
        backgroundColor: "#ffffff",
        pointerEvents: "auto",
      }}
    >
      <div className="login-container d-flex flex-fill flex-column justify-content-center position-relative w-100 h-100 bg-white">
        <div className="position-relative mw-100 z-2">
          <div className="text-center loginLogo">
            <img
              src={logo}
              width={357}
              height={114}
              className="img-fluid object-fit-contain"
              alt="Logo"
            />
          </div>
          <div className="text-center mb-4 px-4">
            <h2 className="mb-3 text-uppercase fw-bolder fs-4 text-dark">
              {title}
            </h2>
            <p className="mb-0 fs-6 text-secondary">{message}</p>
            {totalMb ? (
              <p className="mb-0 mt-2 fs-6 text-secondary">
                Downloading: {(downloadedMb ?? 0).toFixed(1)} /{" "}
                {totalMb.toFixed(1)} MB
              </p>
            ) : null}
          </div>
          <div className="mt-5 w-75 mx-auto" style={{ maxWidth: "400px" }}>
            <div
              className="rounded-pill"
              style={{
                height: "12px",
                overflow: "hidden",
                border: "1px solid rgba(0,0,0,0.1)",
                backgroundColor: "#e9ecef",
              }}
            >
              <div
                className="progress-bar"
                role="progressbar"
                style={{
                  width: `${progress}%`,
                  height: "100%",
                  transition: "width 0.4s ease-out",
                  backgroundColor: "#000000",
                }}
              />
            </div>
            <div className="d-flex justify-content-between mt-2">
              <span className="fw-bolder text-secondary">Progress</span>
              <span className="fw-bolder text-secondary">{progress}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default FullScreenProgress;
